import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";
import { SelectedZoneSchema } from "./add-redo-carrier-service";

// Starts the setupLandedCostDemoCheckoutTree Temporal workflow (sync metafields
// → create experiences → wrap tree → add carrier service). Returns immediately;
// poll getSetupLandedCostDemoCheckoutTreeStatus for completion.
export const setupLandedCostDemoCheckoutTree = {
  name: "setupLandedCostDemoCheckoutTree" as const,
  input: z.object({
    teamId: zExt.objectId(),
    selectedZones: z.array(SelectedZoneSchema),
  }),
  output: z.null(),
};

export const getSetupLandedCostDemoCheckoutTreeStatus = {
  name: "getSetupLandedCostDemoCheckoutTreeStatus" as const,
  input: z.object({ teamId: zExt.objectId() }),
  output: z.object({ isRunning: z.boolean(), failed: z.boolean() }),
};
